export const STATUSES = [
  { key: "idee", label: "Idée", cls: "bg-cream text-ink-soft border border-line" },
  { key: "redaction", label: "En rédaction", cls: "bg-amber-50 text-amber-800 border border-amber-200" },
  { key: "a_relire", label: "À relire", cls: "bg-sky-50 text-sky-800 border border-sky-200" },
  { key: "pret", label: "Prêt", cls: "bg-emerald-50 text-emerald-800 border border-emerald-200" },
  { key: "planifie", label: "Planifié", cls: "bg-bordeaux-tint text-bordeaux border border-bordeaux-border" },
  { key: "publie", label: "Publié", cls: "bg-bordeaux text-white border border-bordeaux" },
];
export const STATUS_MAP = Object.fromEntries(STATUSES.map((s) => [s.key, s]));
export const FORMATS = ["Réel", "Carrousel"];
export const OBJECTIFS = ["Éveiller", "Nourrir", "Convertir"];
export const METRICS = [
  { key: "views", label: "Vues" },
  { key: "likes", label: "Likes" },
  { key: "comments", label: "Commentaires" },
  { key: "shares", label: "Partages" },
  { key: "saves", label: "Enregistr." },
  { key: "followers", label: "Abonnés +" },
];
export const MONTHS = ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"];
export const DAYS = ["Lun", "Mar", "Mer", "Jeu", "Ven", "Sam", "Dim"];
export const DAYS_LONG = ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"];

export const toIso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
export const parseIso = (s) => { const [y, m, d] = s.slice(0, 10).split("-").map(Number); return new Date(y, m - 1, d); };
export const addDays = (d, n) => { const x = new Date(d); x.setDate(x.getDate() + n); return x; };
export const weekStart = (d = new Date()) => { const x = new Date(d.getFullYear(), d.getMonth(), d.getDate()); x.setDate(x.getDate() - ((x.getDay() + 6) % 7)); return x; };
export const inWeek = (iso, ws) => !!iso && iso >= toIso(ws) && iso <= toIso(addDays(ws, 6));
export const inMonth = (iso, y, m) => !!iso && iso.slice(0, 7) === `${y}-${String(m + 1).padStart(2, "0")}`;
export const dow = (iso) => (parseIso(iso).getDay() + 6) % 7;
export const fmtDay = (iso) => { if (!iso) return "—"; const d = parseIso(iso); return `${d.getDate()} ${MONTHS[d.getMonth()]}`; };
const MONTHS_SHORT = ["janv.", "févr.", "mars", "avr.", "mai", "juin", "juil.", "août", "sept.", "oct.", "nov.", "déc."];
export const fmtShort = (iso) => { const d = parseIso(iso); return `${d.getDate()} ${MONTHS_SHORT[d.getMonth()]}`; };
export const fmtNum = (n) => (n || 0).toLocaleString("fr-FR");
export const fmtK = (n) => (n >= 1000 ? `${(n / 1000).toFixed(1).replace(".", ",").replace(",0", "")}k` : String(n || 0));
export const daysSince = (iso) => Math.max(0, Math.round((new Date() - new Date(iso)) / 864e5));

export const isoWeek = (d) => {
  const t = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  t.setUTCDate(t.getUTCDate() + 4 - (t.getUTCDay() || 7));
  return Math.ceil(((t - Date.UTC(t.getUTCFullYear(), 0, 1)) / 864e5 + 1) / 7);
};
export const weeksOfMonth = (y, m) => {
  const out = [];
  const last = new Date(y, m + 1, 0);
  for (let ws = weekStart(new Date(y, m, 1)); ws <= last; ws = addDays(ws, 7)) out.push(ws);
  return out;
};

export const engagement = (m) => {
  if (!m || !m.views) return null;
  return ((m.likes + m.comments + m.shares + m.saves) / m.views) * 100;
};
export const fmtPct = (v) => (v == null ? "—" : `${v.toFixed(1).replace(".", ",")} %`);
export const sumMetrics = (items) => items.reduce((acc, i) => {
  Object.keys(i.metrics || {}).forEach((k) => { acc[k] = (acc[k] || 0) + (i.metrics[k] || 0); });
  return acc;
}, { views: 0, likes: 0, comments: 0, shares: 0, saves: 0, followers: 0 });

export const igEmbed = (url) => {
  const m = (url || "").match(/instagram\.com\/(?:[\w.]+\/)?(p|reel|reels|tv)\/([A-Za-z0-9_-]+)/);
  return m ? `https://www.instagram.com/${m[1] === "reels" ? "reel" : m[1]}/${m[2]}/embed/` : null;
};

export const apiBase = (clientId) => (clientId ? `/admin/clients/${clientId}` : "/client");
